import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["bs-icon-button", {
            'bs-icon-button--gray': _ctx.color === 'gray',
            'bs-icon-button--white': _ctx.color === 'white',
            'bs-icon-button--transparent-blue': _ctx.color === 'transparent-blue',
            'bs-icon-button--medium': _ctx.size === 'medium',
        }]),
    disabled: _ctx.disabled
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 10, _hoisted_1))
}